import axios from 'axios';

const API_BASE_URL = 'https://backfacturas.rmtagency.es/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

console.log('API Base URL:', API_BASE_URL);
console.log('Initial Token:', localStorage.getItem('token') || sessionStorage.getItem('token') || '');
console.log(api.defaults.headers.Authorization);


api.interceptors.request.use((config) => {
  // Try localStorage first, then sessionStorage
  let token = localStorage.getItem('token');
  if (!token) {
    token = sessionStorage.getItem('token');
    if (token) {
      localStorage.setItem('token', token);
    }
  }
  
  // Only log for non-login requests if no token
  if (!token && !config.url?.includes('/auth/login')) {
    console.warn('NO TOKEN AVAILABLE for request to:', config.url);
  }
  
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only redirect to login on 401 if it's not a login request
    // and it's actually an authentication failure (not a validation error)
    if (error.response?.status === 401 && 
        !error.config?.url?.includes('/auth/login') &&
        error.response?.statusText === 'Unauthorized') {
      
      // Only clear storage and redirect if we're sure it's an auth failure
      const errorMessage = error.response?.data?.message || '';
      if (!errorMessage.toLowerCase().includes('invalid') && 
          !errorMessage.toLowerCase().includes('validation')) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (credentials: { username: string; password: string }) =>
    api.post('/auth/login', credentials),
};

export const clientAPI = {
  getAll: () => api.get('/clients'),
  getById: (id: number) => api.get(`/clients/${id}`),
  create: (client: any) => api.post('/clients', client),
  update: (id: number, client: any) => api.put(`/clients/${id}`, client),
  delete: (id: number) => api.delete(`/clients/${id}`),
  search: (name: string) => api.get(`/clients/search?name=${name}`),
};

export const productAPI = {
  getAll: () => api.get('/products'),
  getActive: () => api.get('/products/active'),
  getById: (id: number) => api.get(`/products/${id}`),
  create: (product: any) => api.post('/products', product),
  update: (id: number, product: any) => api.put(`/products/${id}`, product),
  delete: (id: number) => api.delete(`/products/${id}`),
  search: (name: string) => api.get(`/products/search?name=${name}`),
};

export const quoteAPI = {
  getAll: () => api.get('/quotes'),
  getById: (id: number) => api.get(`/quotes/${id}`),
  create: (quote: any) => api.post('/quotes', quote),
  update: (id: number, quote: any) => api.put(`/quotes/${id}`, quote),
  updateStatus: (id: number, status: string) => api.patch(`/quotes/${id}/status`, { status }),
  delete: (id: number) => api.delete(`/quotes/${id}`),
  generatePDF: (id: number) => api.get(`/quotes/${id}/pdf`, { responseType: 'blob' }),
  sendEmail: (id: number) => api.post(`/quotes/${id}/send`),
  convertToInvoice: (id: number, data: any) => api.post(`/quotes/${id}/convert-to-invoice`, data),
};

export const invoiceAPI = {
  getAll: () => api.get('/invoices'),
  getById: (id: number) => api.get(`/invoices/${id}`),
  create: (invoice: any) => api.post('/invoices', invoice),
  update: (id: number, invoice: any) => api.put(`/invoices/${id}`, invoice),
  updateStatus: (id: number, status: string) => api.patch(`/invoices/${id}/status`, { status }),
  delete: (id: number) => api.delete(`/invoices/${id}`),
  generatePDF: (id: number) => api.get(`/invoices/${id}/pdf`, { responseType: 'blob' }),
  sendEmail: (id: number) => api.post(`/invoices/${id}/send`),
};

export default api;